import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';

import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Moment } from 'moment';

import { JSR310ConversionService }  from '../services/jsr310-conversion.service';
import { LocalDate } from '../types/local-date.type';

@Component({
	selector: 'date-input',
	templateUrl: 'date-input.html',
	styleUrls: ['date-input.css']
})
export class DateInputComponent {
	date: Date | null = null;
	minDate: Date | null = null;
	maxDate: Date | null = null;

	constructor( //
		@Inject(JSR310ConversionService) private conversionService: JSR310ConversionService
	) { }

	@Input() id!: string;
	
	@Input() disabled: boolean = false;
	
	@Input() set localDateMin (value: LocalDate | null) {
		let minDate = this.conversionService.fromNullableLocalDate(value);
		this.minDate = minDate;
	}
	
	@Input() set localDateMax (value: LocalDate | null) {
		let maxDate = this.conversionService.fromNullableLocalDate(value);
		this.maxDate = maxDate;
	}

	@Input() set localDate(value: LocalDate | number[] | null) {
		let date = this.conversionService.fromNullableLocalDate(value);
		this.date = date;
	}
	get localDate(): LocalDate | null {
		let localDate = this.conversionService.toNullableLocalDate(this.date);
		return localDate;
	}

	@Output() localDateChange = new EventEmitter<LocalDate | null>();
	
	onDateChange(event: MatDatepickerInputEvent<Moment>) {
		// Convertir la valeur issue du DatePicker en date
		let moment: Moment | null = event.value;
		this.date = moment ? moment.toDate() : null;

		// Si la date est renseignee, verifier qu'elle respecte les min/max indiques
		if (this.date) {
			if (this.minDate && this.date < this.minDate) {
				this.date = this.minDate;
			} else if (this.maxDate && this.date > this.maxDate) {
				this.date = this.maxDate;
			}
		}
		
		// Profiter de la logique du getter de localDate ensuite
		this.localDateChange.emit(this.localDate);
	}
}